/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseFieldType = {
    BasicField: 'BASIC_FIELD',
    CalcField: 'CALC_FIELD',
    CategoryField: 'CATEGORY_FIELD',
    ChecklistField: 'CHECKLIST_FIELD',
    CombinedTextField: 'COMBINED_TEXT_FIELD',
    CreatedByField: 'CREATED_BY_FIELD',
    CreatedDateField: 'CREATED_DATE_FIELD',
    CurrencyField: 'CURRENCY_FIELD',
    DateField: 'DATE_FIELD',
    EmailField: 'EMAIL_FIELD',
    FileField: 'FILE_FIELD',
    ImageField: 'IMAGE_FIELD',
    ImageSeriesField: 'IMAGE_SERIES_FIELD',
    LinkField: 'LINK_FIELD',
    ModifiedByField: 'MODIFIED_BY_FIELD',
    ModifiedDateField: 'MODIFIED_DATE_FIELD',
    NumberField: 'NUMBER_FIELD',
    OwnerField: 'OWNER_FIELD',
    PasswordField: 'PASSWORD_FIELD',
    PercentageField: 'PERCENTAGE_FIELD',
    PeriodField: 'PERIOD_FIELD',
    RatingField: 'RATING_FIELD',
    AgileField: 'AGILE_FIELD',
    StatisticsField: 'STATISTICS_FIELD',
    TelnumberField: 'TELNUMBER_FIELD',
    TextField: 'TEXT_FIELD',
    VideoField: 'VIDEO_FIELD',
    YesNoField: 'YES_NO_FIELD'
} as const;
export type DatabaseFieldType = typeof DatabaseFieldType[keyof typeof DatabaseFieldType];


export function DatabaseFieldTypeFromJSON(json: any): DatabaseFieldType {
    return DatabaseFieldTypeFromJSONTyped(json, false);
}

export function DatabaseFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFieldType {
    return json as DatabaseFieldType;
}

export function DatabaseFieldTypeToJSON(value?: DatabaseFieldType | null): any {
    return value as any;
}

